interface FeatureOptions {
  pdfPaywallEnabled: boolean;
}

export const getFreeFeatures = ({ pdfPaywallEnabled }: FeatureOptions): string[] => {
  const features = ["25 notes per month", "25 chat messages per month"];
  if (pdfPaywallEnabled) features.push("25 PDF pages in search and chat");
  return features;
};

export const getProFeatures = ({ pdfPaywallEnabled }: FeatureOptions): string[] => {
  const features = [
    "Dark mode",
    "AI model selection",
    "Unlimited notes",
    "Unlimited chat messages",
    "Unlimited Deep Searches",
    "Unlimited collections",
    "Unlimited templates",
    "Unlimited connected emails",
    "Unlimited API keys",
  ];
  if (pdfPaywallEnabled) features.push("Unlimited PDFs in search and chat");
  return features;
};
